<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create EPF
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="success"
      title="Employees' Provident Fund"
      text="Create EPF"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="wages_from"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('from')"
                data-vv-name="from"                
                data-vv-as="From"      
                prefix="RM"          
                label="From"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="wages_to"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('to')"
                data-vv-name="to"                
                data-vv-as="To"  
                prefix="RM"          
                label="To"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="employee_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('employee_contribution')"
                data-vv-name="employee_contribution"                
                data-vv-as="Employee Contribution"                
                label="Employee Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="employer_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('employer_contribution')"
                data-vv-name="employer_contribution"                
                data-vv-as="Employer Contribution"                
                label="Employer Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="total_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('total_contribution')"
                data-vv-name="total_contribution"                
                data-vv-as="Total Contribution"                
                label="Total Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="employeeDefaultEpfRate"
                :error-messages="errors.collect('employeeDefaultEpfRate')"
                :items="employeeDefaultEpfRates"
                data-vv-name="key"
                data-vv-as="employeeDefaultEpfRate"
                item-text="name"
                item-value="key"
                label="Employee EPF Default Rate"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="category"
                :error-messages="errors.collect('category')"
                :items="categories"
                data-vv-name="key"
                data-vv-as="category"
                item-text="name"
                item-value="key"
                label="EPF Category / Part"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    data () {
      return {
        categories: [
          { key: 'A', name: 'A' },
          { key: 'E', name: 'E' },
        ],
        employeeDefaultEpfRates: [
          { key: 900, name: '9.00%' },
          { key: 1100, name: '11.00%' },
        ],
        progressing: false,
        dialog: null,
        wages_from: null,
        wages_to: null,
        employer_contribution: null,
        employee_contribution: null,
        total_contribution: null,
        category: null,
        employee_default_epf_rate: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },

    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },

    methods: { 
      prepareFormData () {
        return {
          wages_from: this.wages_from * 100,
          wages_to: this.wages_to * 100,
          employer_contribution: this.employer_contribution * 100,
          employee_contribution: this.employee_contribution * 100,
          total_contribution: this.total_contribution * 100,
          category: this.category,
          employeeDefaultEpfRate: this.employee_default_epf_rate,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.epf().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new EPF' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.wages_from = null
        this.wages_to = null
        this.employer_contribution = null
        this.employee_contribution = null
        this.total_contribution = null
        this.category = null
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
